import type { MessageHandlerDeps } from '../../../routing/message-handler-deps.js';
import type { ApiToBridgeSessionRequestResponseMessage } from '../../../types/api-to-bridge-messages.js';

/** Handle session/agent request resolution from the API (`cursor_request_response` on the wire). */
export function handleBridgeSessionRequestResponse(
  msg: ApiToBridgeSessionRequestResponseMessage,
  { acpManager }: MessageHandlerDeps,
): void {
  if (typeof msg.requestId !== 'string') return;
  acpManager.resolveRequest(msg.requestId, msg.result ?? {});
}
